<template>
    <!-- Oncly Clients should be able to see this modal -->
    <!-- modal-xl -->
    <b-modal id="certificateViewModal" size="xl" title="Certificate View" title-class="font-18" hide-footer>
        <div class="row row-container">
            <div class="left-pane">
                <div>
                    <b-tabs content-class="mt-3">
                        <b-tab title="Certificate" active>
                            <div class="container">
                                <div class="label">Supplier Name:</div>
                                <!-- <div class="data">{{ selected_supplier_details.supplier_name }}</div> -->
                                <div class="data">{{ ifEmpty(selected_supplier_details.supplier_name) }}</div>
                            </div>

                            <div class="container">
                                <div class="label">BEE Level:</div>
                                <div class="data">{{ ifEmpty(selected_supplier_certificate.bbbee_level) }}</div>
                            </div>

                            <div class="container">
                                <div class="label">Company Size:</div>
                                <div class="data">{{ ifEmpty(selected_supplier_certificate.company_size) }}</div>
                            </div>

                            <div class="container">
                                <div class="label">Sector Code:</div>
                                <div class="data">{{ ifEmpty(selected_supplier_certificate.sector_code_id) }}</div>
                            </div>

                            <div class="container">
                                <div class="label">Vat no</div>
                                <div class="data">{{ ifEmpty(selected_supplier_certificate.vat_no) }}</div>
                            </div>
                            <div class="container">
                                <div class="label">Company Reg No:</div>
                                <div class="data">{{ ifEmpty(selected_supplier_certificate.company_reg) }}</div>
                            </div>

                            <div class="container">
                                <div class="label">Issue Date</div>
                                <div class="data">{{ ifEmpty(selected_supplier_certificate.issue_date.substring(0, 10)) }}</div>
                            </div>

                            <div class="container">
                                <div class="label">Expiry Date:</div>
                                <div class="data">{{ ifEmpty(selected_supplier_certificate.expiry_date.substring(0, 10)) }}</div>
                            </div>

                            <div class="container">
                                <div class="label">Share Status:</div>
                                <div class="data">{{ ifEmpty(selected_supplier_certificate.share_status) }}</div>
                            </div>

                            <div class="container">
                                <div class="label">Document Type:</div>
                                <div class="data">{{ ifEmpty(selected_supplier_certificate.document_type) }}</div>
                            </div>

                            <div v-if="selected_supplier_certificate.document_type == 'Certificate'" class="container">
                                <div class="label">Agency:</div>
                                <div class="data">{{ ifEmpty(selected_supplier_certificate.verification_agency_id) }}</div>
                            </div>
                            <!-- <div v-if="selected_supplier_certificate.document_type == 'Certificate'" class="container">
                                <div class="label">Issuer:</div>
                                <div class="data">{{ ifEmpty(selected_supplier_certificate.agency_id }}</div>
                            </div> -->
                        </b-tab>
                        <b-tab title="BBBEE Data">
                            <!-- <div class="container">
                                <div class="label">Economic Interest:</div>
                                <div class="data">{{ economicInterestPercent }}</div>
                            </div>

                            <div class="container">
                                <div class="label">Voting Rights:</div>
                                <div class="data">{{ votingRightsPercent }}</div>
                            </div> -->
                            <div class="container">
                                <div class="label-wide">Ownership Score:</div>
                                <div class="data-wide">{{ ifEmpty(selected_supplier_certificate.own_score) }}</div>
                            </div>
                            <div class="container">
                                <div class="label-wide">Management Control Score:</div>
                                <div class="data-wide">{{ ifEmpty(selected_supplier_certificate.mc_score) }}</div>
                            </div>
                            <div class="container">
                                <div class="label-wide">Socio Economic Development Score:</div>
                                <div class="data-wide">{{ ifEmpty(selected_supplier_certificate.sed_score) }}</div>
                            </div>
                            <div class="container">
                                <div class="label-wide">Enterprise & Supplier Development Score:</div>
                                <div class="data-wide">{{ ifEmpty(selected_supplier_certificate.esd_score) }}</div>
                            </div>
                            <div class="container">
                                <div class="label-wide">Preferential Procurement Score:</div>
                                <div class="data-wide">{{ ifEmpty(selected_supplier_certificate.pp_score) }}</div>
                            </div>
                            <div class="container">
                                <div class="label-wide">Skills Development Score:</div>
                                <div class="data-wide">{{ ifEmpty(selected_supplier_certificate.sd_score) }}</div>
                            </div>
                            <div v-if="selected_supplier_certificate.sector_code_id == 'Financial'" class="container">
                                <div class="label-wide">Access to Finance Score:</div>
                                <div class="data-wide">{{ ifEmpty(selected_supplier_certificate.sd_score) }}</div>
                            </div>
                            <div v-if="selected_supplier_certificate.sector_code_id == 'Financial'" class="container">
                                <div class="label-wide">Empowerment Finance Score:</div>
                                <div class="data-wide">{{ ifEmpty(selected_supplier_certificate.ef_score) }}</div>
                            </div>
                            <div class="container">
                                <div class="label-wide">Enterprise Development Score:</div>
                                <div class="data-wide">{{ ifEmpty(selected_supplier_certificate.ed_score) }}</div>
                            </div>
                            <div class="container">
                                <div class="label-wide">Total Score:</div>
                                <div class="data-wide">{{ ifEmpty(selected_supplier_certificate.total_score) }}</div>
                            </div>
                            <div class="container">
                                <div class="label-wide">Yes Enhancement:</div>
                                <div class="data-wide">{{ ifEmpty(selected_supplier_certificate.yes_enhancement) }}</div>
                            </div>
                            <div class="container">
                                <div class="label-wide">Flow Through Applied:</div>
                                <div class="data-wide">{{ ifEmpty(selected_supplier_certificate.flow_through_applied) }}</div>
                            </div>
                            <div class="container">
                                <div class="label-wide">Designated Group Supplier:</div>
                                <div class="data-wide">{{ ifEmpty(selected_supplier_certificate.designated_group_supplier) }}</div>
                            </div>
                        </b-tab>
                    </b-tabs>
                </div>

                <div class="group-of-actions d-flex justify-content-center">
                    <!-- <div class="group-of-actions d-flex "> -->
                    <b-button @click="newWindow" variant="primary" type="button" class="btn btn-primary m-1 mt-2">
                        <i class="mdi mdi-dock-window mr-1"></i> View
                    </b-button>

                    <b-button
                        v-if="findPermission('Download Certificates') || isTypeUser"
                        @click="downloadFile"
                        variant="primary"
                        type="button"
                        class="btn btn-primary m-1 mt-2 float-right"
                        src="@/assets/images/beesmart-logo.png"
                    >
                        Download Certificate
                    </b-button>
                </div>
            </div>

            <!-- <b-overlay :show="!show" rounded="sm" class="right-pane"> -->
            <div class="right-pane" v-if="selectedFile">
                <!-- <div>
                    <b-button @click="newWindow" variant="primary" class="btn btn-primary float-right mb-2"
                        ><i class="mdi mdi-dock-window mr-1"></i> View</b-button
                    >
                </div> -->

                <embed :src="selectedFilePreview" class="w-100 h-100" />

                <!-- <embed :src="selectedFilePreview" class="w-100 h-100" /> -->
            </div>
            <!-- show if no certifacate in pane -->
            <div v-else class="right-pane">
                <div class="text-center font-weight-bold ">Upload a certificate to preview it</div>
            </div>
            <!-- </b-overlay> -->
        </div>

        <div class="modal-footer mt-3">
            <!-- <b-button variant="primary" type="button" class="btn btn-primary">
                Save
            </b-button> -->
            <b-button variant="primary" type="button" class="btn btn-primary" @click="goBack">
                Back
            </b-button>
            <b-button variant="primary" type="button" class="btn btn-primary" @click="closeModal">
                Close
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import { adminComputed, suppliersComputed, suppliersMethods } from "../../state/helpers";

export default {
    data: () => ({
        show: true,
        selected_doc_type: null,
        selectedFile: "",
        selectedFilePreview: "",
    }),
    computed: {
        ...adminComputed,
        ...suppliersComputed,

        agency_options() {
            let agency_options = [{ value: null, text: "None", disabled: true }];

            this.agencies.map((agency) => {
                agency_options.push({ value: agency.id, text: agency.name });
            });

            return agency_options;
        },
        economicInterestPercent() {
            if (this.selected_supplier_certificate.black_economic_interest == null) {
                return "";
            } else {
                return `${this.selected_supplier_certificate.black_economic_interest} %`;
            }
        },
        votingRightsPercent() {
            if (this.selected_supplier_certificate.black_voting_rights == null) {
                return "";
            } else {
                return `${this.selected_supplier_certificate.black_voting_rights} %`;
            }
        },
    },
    methods: {
        ...suppliersMethods,
        ifEmpty(val) {
            if (val == null || val.length == 0) {
                return "-";
            }
            return val;
        },
        downloadFile() {
            //eslint-disable-next-line
            console.log("dd", this.selected_supplier_certificate);

            this.downloadCertificate(this.selected_supplier_certificate.id).then(() => {});
        },
        goBack() {
            this.$emit("handleModal", "certificateListModal");
            this.closeModal();
        },
        closeModal() {
            this.$bvModal.hide("certificateViewModal");
        },
        newWindow() {
            window.open(this.selectedFilePreview, "_blank");
        },
        localSettings() {
            this.selectedFile = this.selected_supplier_certificate.certificate_src + "#page=1&zoom=75&toolbar=0";
            this.selectedFilePreview = this.selected_supplier_certificate.certificate_src+ "#page=1&zoom=75&toolbar=0";
        }
    },
    mounted() {
        this.setAgencies();        
        this.localSettings();
    },
};
</script>

<style lang="scss" scoped>
//   the default style attached to modal footer  border-top: 1px solid #eff2f7;
// .align-text-setting {
//     text-align: right;
// }
.height {
    height: 500px;
}

// this makes the left and right pane in the flex
.row-container {
    display: flex;
    padding: 10px;
}

.left-pane {
    width: 40%;

    .b-form-group {
        margin-right: 30px;
    }
    .b-form-input {
        max-width: 100%;
    }
    .container {
        display: flex;
        width: 100%;
    }
    .label {
        width: 40%;
        text-align: right;
        margin-right: 25px;
        margin-bottom: 10px;
    }
    .data {
        width: 60%;
        text-align: left;
    }
    .label-wide {
        width: 65%;
        text-align: right;
        margin-right: 25px;
        margin-bottom: 10px;
    }
    .data-wide {
        width: 25%;
        text-align: left;
    }
}
.group-of-actions {
    border-top: 1px solid #eff2f7 !important;
    margin-top: 25px;
    padding-top: 15px;
    margin-right: 25px;
}

.right-pane {
    // padding: 4px;
    width: 59%;
    display: flex;
    flex-direction: column;
    border: 1px solid black;
}

// the purpose of this media query is simply to make the contents of modal display flex-column
// and then for the panes to have a width off 100% instead of 50%
@media only screen and (max-width: 990px) {
    .align-text-setting {
        text-align: left;
    }
    .row-container {
        flex-direction: column;
    }

    .left-pane {
        width: 100%;
    }

    .right-pane {
        width: 100%;
        margin-top: 25px;
        height: 350px;
    }
}
</style>
